import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { addDays } from "../../utils";
import 'dayjs/locale/en-au';


type WifiKeyExpiryProps = {

    expiryOptions : string[];
    initialWifiKeyExpiry? :  Dayjs;
    isDisabled : boolean;
    resetWifiKeyExpiry : number;
    // selectWifiKeyExpiry : Dispatch< SetStateAction< Dayjs | null > >;
    selectWifiKeyExpiry : Dispatch< SetStateAction< string | undefined > >;

};

const fieldsetSx = {

    border: '1px solid lightgray',
    borderRadius: '5px', 

};


const getDefaultExpiryDate = ( ) : string => {

    const expiryDate = dayjs( ).toISOString( ).slice( 0, 10 );
    const formattedExpiry = ( new Date( `${ expiryDate }T23:59:59.000` ) ).toISOString( );
    return formattedExpiry;

};


const getExpiryOptionLabel = ( expiryOption: string ) : string => {

    switch( expiryOption ) {

        case '1': 
            return 'One Day';
        case '3': 
            return 'Three Days';
        case '7': 
            return 'One Week';
        case 'C': 
            return 'Custom';
        case 'N': 
            return 'Never';
        default:
            return 'Unknown Expiry Option'

    }

};


export const WifiKeyExpiry : React.FC< WifiKeyExpiryProps > = ( props : WifiKeyExpiryProps ) => {

    const { expiryOptions, initialWifiKeyExpiry, isDisabled, resetWifiKeyExpiry, selectWifiKeyExpiry } = props;

    // const tomorrow = getTomorrow( );

    // const [ expiryDate, setExpiryDate ] = useState< Dayjs | null  >( initialWifiKeyExpiry ?? dayjs( tomorrow ) );

    const [ expiryDate, setExpiryDate ] = useState< string  >( getDefaultExpiryDate( ) );
    const [ expiryOption, setExpiryOption ] = useState< string >( '1' );
    // const [ isCustomExpiry, setIsCustomExpiry ] = useState< boolean >( false );

    
    useEffect(( ) => {

        if( initialWifiKeyExpiry ) {

            setExpiryOptionFromExpiryDate( initialWifiKeyExpiry ) 

        } else {

            const expiryDate = dayjs().toISOString( ).slice( 0, 10 );
            const formattedExpiry = ( new Date( `${ expiryDate }T23:59:59.000` ) ).toISOString( );
            setExpiryDate( formattedExpiry );

        }





    },[ ]);


    useEffect(( ) => {

        if( resetWifiKeyExpiry > 0 ) {
            
            reset( );

        }

    },[ resetWifiKeyExpiry ]);


    const handleExpiryDateChange = ( expiry: Dayjs | null ) => {

        if( !expiry ){
            
            return;

        }

        const day = expiry.date( ) < 10 ? `0${ expiry.date( ) }` : `${ expiry.date( ) }`;
        const month = expiry.month( ) + 1 < 10 ? `0${ expiry.month( ) + 1 }` : `${ expiry.month( ) + 1 }`;
        const year = expiry.year( );
        const formattedExpiry = ( new Date( `${ year }-${ month }-${ day }T23:59:59.000` ) ).toISOString( );

        setExpiryDate( formattedExpiry ); 
        selectWifiKeyExpiry( formattedExpiry );

        // setExpiryOptionFromExpiryDate( expiry );
        

    };


    const setExpiryOptionFromExpiryDate = ( expiry: Dayjs ) => {

        if( !expiry.isValid( ) ){ // initial

            setExpiryOption( 'N' );
            // setExpiryDate( null );
            return;

        }

        const today = dayjs( ( new Date( ) ).toISOString( ).slice( 0, 10 ) );
        const diff = ( expiry.diff( today, 'day' ) + 1 ).toString( ); // + 1 because 'one day' option is today

        if( expiryOptions.includes( diff ) ){

            // setIsCustomExpiry( false );
            setExpiryOption( diff );

        } else {

            // setIsCustomExpiry( true );
            setExpiryOption( 'C' );

        }

    };


    const handleExpiryOptionChange = ( event: SelectChangeEvent ) => {

        const selectedExpiryOption = event.target.value;
        
        setExpiryOption( selectedExpiryOption );
        // setIsCustomExpiry( false );

        if( selectedExpiryOption === 'N' ) {

            selectWifiKeyExpiry( undefined );
            // setExpiryDate( null );

        } else if( selectedExpiryOption === 'C' ) {
        
            const defaultExpiryDate = getDefaultExpiryDate( );
            
            setExpiryDate( defaultExpiryDate );
            selectWifiKeyExpiry( defaultExpiryDate );
            
            return;
        
        } else {

            // const expiryDate = dayjs().add( +selectedExpiryOption - 1, 'day' ).toISOString( ).slice(0, 10);
            const expiryDate = addDays( +event.target.value - 1 ).slice( 0, 10 );
            const formattedExpiry = ( new Date( `${ expiryDate }T23:59:59.000` ) ).toISOString( );

            setExpiryDate( formattedExpiry );
            selectWifiKeyExpiry( formattedExpiry );

            // setExpiryDate( dayjs( expiry ) );
            // selectWifiKeyExpiry( dayjs( expiry ) );

        }

    };


    const reset = () => {

        
        // !!! setExpiryDate( dayjs(tomorrow) );

        const expiryDate = dayjs().toISOString( ).slice( 0, 10 );
        const formattedExpiry = ( new Date( `${ expiryDate }T23:59:59.000` ) ).toISOString( );
        setExpiryDate( formattedExpiry );
        setExpiryOption( '1' );
        // setIsCustomExpiry( false );

    };

    return(

        expiryOption === 'C' 
            ?
        <LocalizationProvider dateAdapter={ AdapterDayjs } adapterLocale="en-au">
            
            <DatePicker 
                sx={{ marginTop: '5px' }}
                disabled={ isDisabled }
                label="Expiry Date" 
                value = { expiryDate ? dayjs( expiryDate ) : null }
                onChange={ handleExpiryDateChange }
                minDate={ dayjs( ) }
            />

        </LocalizationProvider>
            :
        <FormControl sx={{ marginTop: '5px' }}>
            <InputLabel>Expiry Option</InputLabel>
            <Select 
                label="Expiry Option"
                onChange={ handleExpiryOptionChange }
                value={ expiryOption }
                disabled={ isDisabled }
                defaultValue=""
            >

                {
                    expiryOptions.map( expiryOption => (
                        <MenuItem value={ expiryOption } key={ expiryOption }> { getExpiryOptionLabel( expiryOption ) }  </MenuItem>
                    ))
                }

            </Select>
        </FormControl>

    );


};